import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { decisionItem } from '@atlaskit/adf-schema';
import { convertToInlineCss } from '@atlaskit/editor-common/lazy-node-view';
import { fg } from '@atlaskit/platform-feature-flags';
// @nodeSpecException:toDOM patch
export var decisionItemSpecWithFixedToDOM = function decisionItemSpecWithFixedToDOM() {
  if (!fg('platform_editor_lazy-node-views')) {
    return decisionItem;
  }
  return _objectSpread(_objectSpread({}, decisionItem), {}, {
    toDOM: function toDOM(node) {
      var _node$attrs = node.attrs,
        localId = _node$attrs.localId,
        state = _node$attrs.state;
      var attrs = {
        'data-decision-local-id': localId || 'local-decision',
        'data-decision-state': state,
        class: 'decisionItemView-content-wrap',
        // Styles to match `packages/elements/task-decision/src/components/styles.ts`
        style: convertToInlineCss({
          background: "var(--ds-background-neutral, rgba(9, 30, 66, 0.04))",
          padding: "var(--ds-space-100, 8px)",
          margin: "var(--ds-space-100, 8px)".concat(" 0 0 0"),
          display: 'flex',
          borderRadius: "var(--ds-border-radius, 4px)"
        })
      };
      return ['li', attrs, ['span', {
        style: convertToInlineCss({
          width: '16px',
          height: '16px',
          margin: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-200, 16px)", " 0 0")
        })
      }], ['div', {
        'data-decision-wrapper': true,
        'data-testid': 'elements-decision-item'
      }, ['div', {
        'data-component': 'content'
      }, ['div', {
        class: 'decision-item'
      }, 0]]]];
    }
  });
};